import Icon from "@core-components/icon/Icon";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Grid, Stack, Text } from "@mantine/core";
import { Link } from "react-router";
import {
  BOLD_TEXT_CLASS_NAME,
  LIGHT_TEXT_CLASS_NAME,
} from "../../pages/OrderTracking";
import SSDivider from "./Divider";
import SSSection from "./Section";

const HowToSecureYourAccount: React.FC = () => {
  const { t } = useAppTranslation("pages.order.tracking.howToSecure");
  const { locationUrlBuilder } = useAppLanguage();

  return (
    <SSSection
      icon={<Icon.GreenShield size={20} />}
      title={t("title")}
      fullHeight={false}
    >
      <Stack className="gap-6 md:gap-5">
        <Grid columns={24} gutter={{ base: 10, md: 50 }}>
          <Grid.Col span={{ base: 24, md: 9 }}>
            <Text className={BOLD_TEXT_CLASS_NAME}>
              {t("changeEmail.title")}
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 24, md: 15 }}>
            <Text className={LIGHT_TEXT_CLASS_NAME}>
              {t("changeEmail.text")}
              <Link
                to={locationUrlBuilder(EPublicRoutes.FAQ_CHANGE_EMAIL)}
                target="_blank"
                rel="noreferrer noopener"
                className="text-secret-purple-default"
              >
                {t("changeEmail.link")}
              </Link>
              {t("changeEmail.suffix")}
            </Text>
          </Grid.Col>
        </Grid>
        <SSDivider />
        <Grid columns={24} gutter={{ base: 10, md: 50 }}>
          <Grid.Col span={{ base: 24, md: 9 }}>
            <Text className={BOLD_TEXT_CLASS_NAME}>
              {t("contactSupport.title")}
            </Text>
          </Grid.Col>
          <Grid.Col span={{ base: 24, md: 15 }}>
            <Text className={LIGHT_TEXT_CLASS_NAME}>
              {t("contactSupport.text")}
            </Text>
          </Grid.Col>
        </Grid>
        <SSDivider />
        <Text className={LIGHT_TEXT_CLASS_NAME}>{t("rpWarning")}</Text>
      </Stack>
    </SSSection>
  );
};

export default HowToSecureYourAccount;
